import type { SVGProps } from "react";

export const FileXIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.3}>
      <path
        d="M27.9996 4.00001H12.0012C10.9404 4.00001 9.92311 4.42147 9.17304 5.17167C8.42297 5.92188 8.00159 6.93937 8.00159 8.00033V40.0029C8.00159 41.0638 8.42297 42.0813 9.17304 42.8315C9.92311 43.5817 10.9404 44.0032 12.0012 44.0032H35.9988C37.0595 44.0032 38.0769 43.5817 38.8269 42.8315C39.577 42.0813 39.9984 41.0638 39.9984 40.0029V16.001M27.9996 4.00001C28.6326 3.99898 29.2596 4.12322 29.8445 4.36557C30.4293 4.60793 30.9604 4.9636 31.4072 5.41212L38.5825 12.5887C39.0322 13.0357 39.3888 13.5675 39.6318 14.1531C39.8748 14.7388 39.9994 15.3669 39.9984 16.001M27.9996 4.00001V14.0008C27.9996 14.5313 28.2103 15.04 28.5853 15.4151C28.9603 15.7902 29.469 16.001 29.9994 16.001L39.9984 16.001M28.9995 25.0017L19.0005 35.0025M19.0005 25.0017L28.9995 35.0025"
        stroke="#556272"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </g>
  </svg>
);
